import { Component, OnInit, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { Question, QuestionResponse } from '../../models/question.model';
import { QuestionService } from '../../services/question.service';
import { NgFor, NgIf } from '@angular/common';
import { QuestionComponent } from '../../shared/components/question/question.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  standalone: true,
  imports: [QuestionComponent, NgFor, NgIf, RouterModule],
  styleUrls: ['./exam.component.css']
})
export class ExamComponent implements OnInit, OnDestroy {
  @ViewChildren(QuestionComponent) questionComponents!: QueryList<QuestionComponent>;

  eid!: string;
  questions: Question[] = [];
  isLoading: boolean = true;

  totalSeconds: number = 0;
  isPaused: boolean = false;
  isHidden: boolean = false;
  interval: any;
  finalTime: string = '';
  hasAccess: boolean = false;
  isPlanChecked: boolean = false;
  isFreePlan: boolean = false;
  userId = Number(localStorage.getItem('id'));
  constructor(private route: ActivatedRoute, private questionService: QuestionService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    this.eid = this.route.snapshot.paramMap.get('eid') || '';

    this.isLoading = true; // Começa carregando

    this.userService.getUserPlan(this.userId).subscribe({
      next: (res) => {
        if (res.plan === 'free') {
          this.isFreePlan = true;
          this.isLoading = false;  // Já pode parar loading
          return;
        }

        this.hasAccess = true;
        this.isFreePlan = false;

        // Carrega as questões e só para o loading após receber as questões
        this.loadQuestions();
      },
      error: () => {
        console.error('Erro ao verificar plano');
        this.isLoading = false;
      }
    });

    this.startTimer();
  }

  loadQuestions() {
    if (!this.eid) {
      console.error('Exam ID não definido');
      this.isLoading = false;
      return;
    }

    this.questionService.getQuestionsExam(this.eid, 1, {}, 100).subscribe({
      next: (response: QuestionResponse) => {
        this.questions = response.questions.data ?? response.questions;
        this.isLoading = false;  // Parar loading quando perguntas carregarem
      },
      error: (error) => {
        console.error('Erro ao carregar as perguntas', error);
        this.isLoading = false;
      }
    });
  }




  get formattedTime(): string {
    const hours = Math.floor(this.totalSeconds / 3600);
    const minutes = Math.floor((this.totalSeconds % 3600) / 60);
    const seconds = this.totalSeconds % 60;
    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(value: number): string {
    return value.toString().padStart(2, '0');
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (!this.isPaused) {
        this.totalSeconds++;
      }
    }, 1000);
  }

  togglePause() {
    this.isPaused = !this.isPaused;
  }

  toggleCounterVisibility() {
    this.isHidden = !this.isHidden;
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  finishExam() {
    this.togglePause();
    this.finalTime = document.getElementById('counter')?.textContent || '00:00:00';
    const results = this.questionComponents.map(question => ({
      isAnswered: question.isAnswered,
      isCorrect: question.isCorrect
    }));

    const correct = results.filter(r => r.isCorrect).length;
    const wrong = results.filter(r => r.isAnswered && !r.isCorrect).length;
    const unanswered = results.filter(r => !r.isAnswered).length;
    const totalQuestions = results.length;

    // Verificação de questões respondidas
    if (correct === 0 && wrong === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Você deve responder pelo menos uma questão para finalizar o exame.',
        confirmButtonText: 'Entendi'
      });
      this.togglePause(); // Reabre o exame se não tiver respostas
      return; // Interrompe a execução do método
    }

    const score = totalQuestions > 0 ? Math.round((correct / totalQuestions) * 100) : 0;

    Swal.fire({
      // Restante do código permanece igual
      title: 'Resultado do Exame',
      html: `
        <div class="text-left">
            <p><i class='bx bx-check-circle text-green-500' style="vertical-align: middle; margin-right: 8px;"></i> Acertos: ${correct}</p>
            <p><i class='bx bx-x-circle text-red-500' style="vertical-align: middle; margin-right: 8px;"></i> Erros: ${wrong}</p>
            <p><i class='bx bx-sad text-gray-500' style="vertical-align: middle; margin-right: 8px;"></i> Não respondidas: ${unanswered}</p>
            <p><i class='bx bx-time text-blue-500' style="vertical-align: middle; margin-right: 8px;"></i> Tempo: ${this.finalTime}</p>
            <p>Total de questões: ${totalQuestions}</p>
        </div>
        `,
      confirmButtonText: 'Salvar'
    }).then((result) => {
      if (result.isConfirmed) {
        // Restante do código permanece igual
        this.questionService.postHistory(
          `#FACSQ${this.eid}`,
          this.eid,
          wrong,
          correct,
          this.finalTime,
          score
        ).subscribe({
          next: () => {
            Swal.fire('Sucesso!', 'Histórico salvo com sucesso.', 'success');
            this.router.navigate(['/']);
          },
          error: () => {
            Swal.fire('Erro!', 'Falha ao salvar o histórico.', 'error');
          }
        });
      }
    });
  }
}
